import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { Icon } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { type ComponentPropsWithoutRef, type Ref } from 'react';
type HeaderProps = ComponentPropsWithoutRef<'header'> & {
  closeRef?: Ref<HTMLButtonElement>;
};
export function Header(t0) {
  const $ = _c(15);
  let children;
  let className;
  let closeRef;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      closeRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = closeRef;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    closeRef = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("side-drawer__header", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon name="x" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== closeRef) {
    t3 = <Dialog.Close ref={closeRef} className="side-drawer__close" aria-label="Close">{t2}</Dialog.Close>;
    $[8] = closeRef;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== t1 || $[13] !== t3) {
    t4 = <header className={t1} {...props}>{children}{t3}</header>;
    $[10] = children;
    $[11] = props;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}